import { render, staticRenderFns } from "./SchoolInvoices.html?vue&type=template&id=62a54ab7&scoped=true&external"
import script from "./SchoolInvoices.js?vue&type=script&lang=js&external"
export * from "./SchoolInvoices.js?vue&type=script&lang=js&external"
import style0 from "./SchoolInvoices.vue?vue&type=style&index=0&id=62a54ab7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a54ab7",
  null
  
)

export default component.exports